import React from 'react';

import { i18n } from 'app/i18n';
import { ActiveOrder } from 'app/page/orders/model/active-order';
import { SelectedProducts } from 'app/components/domain/selected-products';
import { ConnectionAndActivation } from 'app/components/domain/connection-and-activation';
import { Message, MessageType } from 'app/components/domain/message';
import { AdditionalInformation } from 'app/components/domain/additional-information/additional-information';

import { OrderDetailsPlaceholder } from './order-details-placeholder';

interface OwnProps {
    activeOrder: ActiveOrder;
}

type Props = OwnProps;

const OrderDetails: React.FC<Props> = (props) => {
    const { activeOrder } = props;

    if (activeOrder.pendingUpdate) {
        return <OrderDetailsPlaceholder />;
    }

    if (!activeOrder.initialized) {
        return (
            <Message
                type={MessageType.ERROR}
                text={i18n.summary.errorMessage.unableToRetrieveTheOrder}
                description={[i18n.summary.errorMessage.technicalError, i18n.summary.errorMessage.tryAgainLaterOrCall]}
            />
        );
    }

    return (
        <>
            <SelectedProducts activeOrder={activeOrder} />
            <AdditionalInformation />
            <ConnectionAndActivation activeOrder={activeOrder} />
        </>
    );
};

export { OrderDetails };
